import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

export default {
  state: {
    cards: [],
    banners: [],
    userName: '登录'
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/home/index.js